import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-cpf_b29cff6517e2390bd8cec061b755dc04",
  "use": "ic-cpf_b29cff6517e2390bd8cec061b755dc04-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 12\" id=\"ic-cpf_b29cff6517e2390bd8cec061b755dc04\">\n    <path fill=\"#222\" d=\"M0 1a1 1 0 0 1 1-1h9.477a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1z\" />\n    <path stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\".8\" d=\"M2.488 3.6h6.503M2.488 5.6h6.503M2.488 7.6h6.503\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id